import React from "react";
import PropTypes from "prop-types";

import { Link } from "components/core/Link";
import "./Crumb.scss";

const Crumb = ({ label, href, isLast }) => (
	<span className="crumb">
		{isLast ? (
			label
		) : (
			<Link
				href={href}
				weight="semiBold"
				underline
				color="blue"
				hover
			>
				{label}
			</Link>
		)}
	</span>
);

Crumb.defaultProps = {
	href: "",
	isLast: false
};

Crumb.propTypes = {
	label: PropTypes.string.isRequired,
	href: PropTypes.string,
	isLast: PropTypes.bool
};

export default Crumb;
